// Path to the sound file that plays when the AI finishes typing
export const messageCompleteSoundPath = "/aidone.mp3";

// Create an audio element once and reuse it
let audioElement = null;

// Function to play the sound
export const playMessageCompleteSound = () => {
  try {
    // Create audio element if it doesn't exist yet
    if (!audioElement) {
      audioElement = new Audio(messageCompleteSoundPath);
      audioElement.volume = 0.5; // Set volume to 50%
      
      // Preload the audio file
      audioElement.load();
    }
    
    // Reset the audio to the beginning if it was already played
    audioElement.currentTime = 0;
    
    // Play the sound with a user interaction promise to handle autoplay policies
    const playPromise = audioElement.play();
    
    if (playPromise !== undefined) {
      playPromise
        .catch(() => {});
    }
  } catch (error) {
    // Sound playback failed silently
  }
}; 